export default __webpack_public_path__ + "static/media/laptop.c425bcf6.png";